function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M49.291 24.0276V9.99176C49.291 8.61119 48.1706 7.49072 46.79 7.49072H42.1456C40.765 7.49072 39.6445 8.61119 39.6445 9.99176V15.7592",
  stroke: "#2C3589",
  strokeWidth: 3.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.49023 26.784L26.7433 10.2821C28.6165 8.67646 31.3802 8.67646 33.2535 10.2821L52.509 26.784",
  stroke: "#2C3589",
  strokeWidth: 3.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.707 24.0276V47.5074C10.707 50.271 12.9455 52.5095 15.7091 52.5095H27.499",
  stroke: "#2C3589",
  strokeWidth: 3.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M43.7547 55.0108C37.5396 55.0108 32.5 49.9712 32.5 43.7562C32.5 37.5411 37.5396 32.5015 43.7547 32.5015C49.9723 32.5015 55.0094 37.5411 55.0094 43.7562C55.0094 49.9712 49.9723 55.0108 43.7547 55.0108",
  stroke: "#2C3589",
  strokeWidth: 3.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M48.2043 41.5322L42.6469 47.0895L39.3105 43.7557",
  stroke: "#2C3589",
  strokeWidth: 3.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgJoratoShowcasingCreated = function SvgJoratoShowcasingCreated(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJoratoShowcasingCreated, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jorato-showcasing-created.5dc23dbd.svg";
export { ForwardRef as ReactComponent };